import {h, Fragment} from "preact"
import Product from "./Product"
import { useAppState } from "@nosto/preact"
import { useEffect } from "preact/hooks";

export default function Products({isMobile ,isTwoProductsInLayout}) {
    const {
        response: { products },
        loading
    } = useAppState()

    useEffect(() => {
        // Styling ATC buttons based on text
        const atcBtns = document.querySelectorAll(".variant-swatch");
        // console.log(atcBtns)
          atcBtns.forEach((element) => {
            let atcText = element.textContent.trim();
            // console.log(atcText);
            if (atcText !== "Add to cart") {
              element.style.textTransform = "capitalize";
            } else {
              // element.style.border = "none !important";
              element.style.setProperty("border", "none", "important");
            }
          });

        // Adding ATC functionality to quick buy buttons without variant
        const quickBuyWithoutVariant = document.querySelectorAll('.mobile__quick-buy:not(.open-sticky-modal)');
        // console.log(quickBuyWithoutVariant)
        quickBuyWithoutVariant.forEach((quickBuy) => {
            quickBuy.addEventListener('click', (e) => {
                // console.log(quickBuy)
                const productId = quickBuy.getAttribute('product-handle');
                const skuId = quickBuy.getAttribute('sku-handle');
                // console.log(productId, skuId);
                window.Nosto.addSkuToCart({ productId, skuId }, '.ns-serp');
                setTimeout(() => {
                    window.Cart.updateCart();
                }, 1000);
            });
        })
      }, [products]);


    return (
        <ul 
        // class="ns-d-flex ns-flex-wrap"
        class={`search-grid__wrapper collection-products__list collection-products__list--product grid grid-cols-2 md:grid-cols-4 gap-y-40 ns-products-list ${isMobile && isTwoProductsInLayout ? "product-list--per-row-mob-2" : isMobile && !isTwoProductsInLayout ? "product-list--per-row-mob-1": ""}`}
        style={loading ? "opacity: 0.3;" : ""}>
            {products.hits.map((hit, index) => {
                return <Product product={hit} key={hit.productId || index} />
            })}
        </ul>
    )
}
